import type { CSSProperties } from 'react'
import { Link } from 'react-router-dom'
import { Carousel } from '../components/Carousel'
import { LaunchBanner } from '../components/LaunchBanner'
import { CAPABILITIES, SERVICE_LINES } from '../config/site'

function Home() {
  return (
    <>
      <LaunchBanner />
      <section className="hero">
        <div className="container">
          <p className="hero__eyebrow">Cloud · Custom software · AI</p>
          <h1>
            Software that moves your business faster —{' '}
            <span className="accent-text">without cutting corners</span>.
          </h1>
          <p className="tagline">
            Stratum Labs builds and runs cloud-based websites and custom software for growing
            businesses, with AI woven in to cut the manual work. Websites from R500/month, bespoke
            builds, and consulting.
          </p>
          <div className="hero__actions">
            <Link className="btn btn--primary" to="/services">
              See services &amp; pricing
            </Link>
            <Link className="btn btn--ghost" to="/products">
              See products &amp; pricing
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2>Our products &amp; services</h2>
          <div className="product-cards">
            <Link
              className="product-card"
              to="/products"
              style={
                {
                  '--product-card-gradient': 'linear-gradient(135deg, #0d9488, #10b981)',
                } as CSSProperties
              }
            >
              <span className="product-card__eyebrow">Flagship product</span>
              <h3>Talynth</h3>
              <p>
                POPIA compliance in 15 minutes, not 15 weeks — a self-service compliance platform
                for South African SMEs. Guided assessment, instant score, auto-generated legal
                documents.
              </p>
              <span className="product-card__cta">See products &amp; pricing</span>
            </Link>
            <Link
              className="product-card"
              to="/services"
              style={
                {
                  '--product-card-gradient': 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                } as CSSProperties
              }
            >
              <span className="product-card__eyebrow">Services</span>
              <h3>Websites, builds &amp; a second opinion</h3>
              <p>
                Fully managed sites from R500 a month, software built around how you work, and help
                when you need a hand on an existing project — we build and run it so you don&apos;t
                have to.
              </p>
              <span className="product-card__cta">See services &amp; pricing</span>
            </Link>
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <h2>Three ways we help</h2>
          <div className="cards">
            {SERVICE_LINES.map((svc) => (
              <Link className="card card--link" to="/services" key={svc.title}>
                <span className="card__icon" aria-hidden="true">
                  {svc.icon}
                </span>
                <h3>{svc.title}</h3>
                <p>{svc.summary}</p>
                <span className="card__price-label">{svc.priceLabel}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Carousel />
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <h2>How we deliver</h2>
          <p className="lead">The engineering approach behind every build.</p>
          <div className="cards">
            {CAPABILITIES.map((cap) => (
              <Link className="card card--link" to={`/capabilities/${cap.slug}`} key={cap.slug}>
                <span className="card__icon" aria-hidden="true">
                  {cap.icon}
                </span>
                <h3>{cap.title}</h3>
                <p>{cap.summary}</p>
                <span className="card__more">Learn more &rarr;</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <h2>Ready to build something?</h2>
            <p>
              Tell us what you need — a website, a custom build, or a hand on a project — and
              we&apos;ll come back with a clear next step.
            </p>
            <Link className="btn btn--primary" to="/contact">
              Get in touch
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}

export default Home
